import { useNavigate } from 'react-router-dom';
import styles from '../../Style/FeaturesModal.module.scss';
import { Table } from '../FeaturesComponents';
import { analyticsTable, preProcessedAnalyticsTable } from '../FeaturesTables';

type AnalyticsSectionProps = {
  handleCloseAllModals: () => void;
};

export function AnalyticsSection({ handleCloseAllModals }: AnalyticsSectionProps) {
  const navigate = useNavigate();

  const closeAndNavigate = (path: string) => {
    handleCloseAllModals();
    navigate(path);
  };

  return (
    <>
      <h2>Analytics</h2>
      <p>
        The analytics can be used to assess the metocean conditions anywhere in the world. It is
        free of charge to analyze the last year of data from any
        <span className={styles.spanLink} onClick={() => closeAndNavigate('metadata')}>
          {' '}
          dataset
        </span>
        . Holders of a valid
        <span className={styles.spanLink} onClick={() => closeAndNavigate('pricing#subscription')}>
          {' '}
          subscription{' '}
        </span>
        can freely analyze the full period of data (typically 40+ years).
      </p>
      <h3>Interactive analytics</h3>
      <p>
        The interactive analytics are processed on the fly and can be configured by the user. An
        overview of the suite of interactive analytics is given below.
      </p>
      <Table
        th1="Interative analytic"
        th2="Example"
        tableObjects={analyticsTable}
        theme={'light'}
      />
      <div className={styles.preProcessedAnalytics}>
        <h3>Pre-processed analytics</h3>
        <p>
          Pre-processed analytics comprise complex or custom analytics that are processed offline
          within designated areas for certain datasets and made available online. Examples of
          pre-processed analytics from the TNW datasets are given below.
        </p>
        <div className={styles.tableScrollWrapper}>
          <Table
            th1="Pre-processed analytic"
            th2="Example"
            tableObjects={preProcessedAnalyticsTable}
            theme={'light'}
          />
        </div>
      </div>
    </>
  );
}
